import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import DeleteIcon from 'assets/images/icons/delete.svg';

import StyledModal from './StyledModal';
import { ModalProps } from './ModalTypes';

class Modal extends React.Component<ModalProps> {
  constructor(props: ModalProps) {
    super(props);
    this.escFunction = this.escFunction.bind(this);
  }

  componentDidMount(): void {
    document.addEventListener('keydown', this.escFunction, false);
  }

  componentWillUnmount(): void {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  escFunction(event: KeyboardEvent): void {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.props.onDismiss();
    }
  }

  render(): React.ReactElement {
    const { children, visible, onDismiss } = this.props;

    return (
      <StyledModal>
        <AnimatePresence>
          {visible && (
            <motion.div
              className="background"
              style={{
                width: '100vw',
                height: '100vh',
              }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <motion.div
                className="modal"
                initial={{ y: 50, opacity: 0, scale: 0.75 }}
                animate={{ y: 0, opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.75 }}
                transition={{ delay: 0.3 }}
              >
                <img className="delete" src={DeleteIcon} alt="Delete" onClick={onDismiss} />
                {children}
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </StyledModal>
    );
  }
}

export default Modal;
